<template lang="pug">
  .main  
    base-header(ref="jello").pb-1
      b-row.py-4(aling-v='center')
        b-col(cols='7' lg='6')
          h6.h2.text-white.d-inline-block.mb-0 Keyword Listen
  
    b-container(fluid, v-if="config")
      b-row.mt-5
        .py-2.text-muted.text-sm Primäre Keywords einer DCC-Klasse werden immer vorranging gewertert.<br/>Sekundäre Keywords werden nur für die Klassifikation von Inhaltsverzeichniskapitel verwendet.
        table.table
          tr
            td(colspan="4")
              .d-flex.justify-content-end
               
                b-button(v-on:click="add(selected)", variant="secondary", size="sm") Eintrag hinzufügen
          
          tr
            th(width="20%") Klasse (e.g. DCC)
            th Primäre Keywords 
            th Empfehlungen
            th Aktion
          
          // add entry
          
          tr(v-for="item in config.configurations")
            td 
              b-form-input(v-model="item.dcc_class", type="text", placeholder="DCC Klasse")
              b-form-input(v-model="item.label", type="text", placeholder="Label")
              
              b-form-checkbox(v-model="item.is_document_class", :value="true", :unchecked-value="false") Ist eine Dokumenten-Klasse (DCC)
              b-form-checkbox(v-model="item.keep_whole_document", :value="true", :unchecked-value="false") Standard: Bei Klassifikation gesamtes Dokument erhalten
              b-form-checkbox(v-model="item.always_export_split", :value="true", :unchecked-value="false") Standard: Splits auf "Export" setzen
              b-form-checkbox(v-model="item.single_chapter", :value="true", :unchecked-value="false") Klassifiziere nur ein Kapitel (Hauptkapitel, wenn möglich)
              b-form-checkbox(v-model="item.is_system_class", :value="true", :unchecked-value="false") System-Keywords
  
            td
              .small.mb-1 Primär
              textarea(autosize).form-control(v-model="item.keywords_primary", rows="14")
              .small.mt-2.mb-1 Sekundär
              textarea.form-control(v-model="item.keywords_secondary", rows="8")
            td
              b Empfehlungen (Dokumente)
              ul(v-if="item.recommendations", style="max-width: 300px").list-group
                li(v-for="it in item.recommendations.keywords_text", v-if="item.keywords_primary.split('\\n').indexOf(it.keyword) === -1")
                  a(@click="item.keywords_primary += '\\n' + it.keyword", role="button", style="cursor: pointer").cp {{ it.keyword }} ({{ it.count }})
                  
              
            td
           
              b-button(v-on:click="remove(item.uuid)", variant="primary")
                i.fa.fa-trash
          
          tr
            td(colspan="4")
              .d-flex.justify-content-end
               
                b-button(v-on:click="add(selected)", variant="secondary", size="sm") Eintrag hinzufügen
      
      b-row.mt-2
        b-col(cols='7' lg='6')
          b-button(v-on:click="save_config(config)", variant="primary") Speichern
  
  
  
  
  
  </template>
  <script>
    // Charts
    import Vue from 'vue';
    
    export default {
      components: {
     
      },
      data() {
        return {
          options: null,
          config: null,
          selected: null,     
        } 
      },
      methods: {
  
        remove(uuid) {
  
          // get item
          let item = this.config.configurations.find(x => x.uuid === uuid);
  
  
          // confirm
          this.$bvModal.msgBoxConfirm('Soll der Eintrag "' + item.dcc_class + '" wirklich entfernt werden?')
            .then(value => {
              if (value) {
                let index = this.config.configurations.findIndex(x => x.uuid === uuid);
                if (index > -1) {
                  this.config.configurations.splice(index, 1);
                }
                
              }
            })
            .catch(err => {
              // An error occurred
            });
  
          
        },
  
        moveUp(uuid) {
          let index = this.config.configurations.findIndex(x => x._id === uuid);
          if (index > 0) {
            this.config.configurations.splice(index - 1, 0, this.config.configurations.splice(index, 1)[0]);
          }
        },
  
        moveDown(uuid) {
          let index = this.config.configurations.findIndex(x => x._id === uuid);
          if (index < this.config.configurations.length - 1) {
            this.config.configurations.splice(index + 1, 0, this.config.configurations.splice(index, 1)[0]);
          }
        },
  
        add(selected) {
          this.config.configurations.push({
            "dcc_class": selected,
            "keywords_primary": "",
  
            "keywords_secondary": ""
          });
        },
  
        fetch() {
          this.axios.get(this.base_url + '/configuration/keywords').then((response) => {
          // order
          response.data.configurations.sort((a, b) => (a.dcc_class > b.dcc_class) ? 1 : -1);
          // give ids
          for (let i = 0; i < response.data.configurations.length; i++) {
            response.data.configurations[i].uuid = i;
          }
  
          // rewrite array to textarea
          for (let i = 0; i < response.data.configurations.length; i++) {
            response.data.configurations[i].keywords_primary = response.data.configurations[i].keywords_primary.join("\n");
            response.data.configurations[i].keywords_secondary = response.data.configurations[i].keywords_secondary.join("\n");
          }
          this.config = response.data;
          });
  
        },
  
        save_config(ic) {
          // rewrite textarea to array
          let to_send = JSON.parse(JSON.stringify(ic));
          for (let i = 0; i < ic.configurations.length; i++) {
            to_send.configurations[i].keywords_primary = ic.configurations[i].keywords_primary.split("\n");
            to_send.configurations[i].keywords_secondary = ic.configurations[i].keywords_secondary.split("\n");
          }
          this.axios.post(this.base_url + '/configuration/keywords', to_send).then((response) => {
            this.options = response.data;
            this.$bvToast.toast("Keywords gespeichert", {
              title: "Keywords gespeichert",
              variant: 'primary',
              autoHideDelay: 1000,
            });
            this.fetch(); 
          });
        },
  
      
        
      },
      watch: {
       
      },
  
  
  
      async mounted() {
        this.fetch();
      
  
      
  
      }
    };
  </script>
  <style></style>
  